import { render, staticRenderFns } from "./AccountPerseusTable.vue?vue&type=template&id=6922a125&"
import script from "./AccountPerseusTable.vue?vue&type=script&lang=js&"
export * from "./AccountPerseusTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports